import React from "react"
import {useTranslation} from "react-i18next"

import {SelectField} from "~/components/"
import ShelfApi from "~/utils/ShelfApi.js"

const LanguageSwitch = () => {
  const {i18n} = useTranslation()
  const lngs = [
    {id: "de", name: "Deutsch"},
    {id: "fr", name: "Français"}
  ]
  return (
    <div style={{marginTop: 10, marginBottom: 10}}>
      <SelectField
        options={lngs}
        value={i18n.language || i18n.resolvedLanguage}
        onChange={lng => {
          i18n.changeLanguage(lng)
          ShelfApi.changeLanguage(lng)
        }}
      />
    </div>
  )
}

export default LanguageSwitch



// WEBPACK FOOTER //
// ./src/components/navigations/LanguageSwitch.js